export default {
  products: [], // all market place products
  product: null, // single market place product
  sellers_total_product: 0, // seller's total product in market place,
  seller: null, // seller information
  productImages: [], // product images
  similar_products: [], // similar products
  loading: false, // marketplace loader
  total: 0,
  filteredCount: 0
}
  